"use strict";

export default function () {
    (function () {
        function setActive(root, idx) {
            const center = root.querySelector(".o-solutions-circle__center");
            const allCenterItems = center.querySelectorAll(
                ".o-solutions-circle__center-item"
            );
            const main = center.querySelector(
                ".o-solutions-circle__center-item--main"
            );
            const items = root.querySelectorAll(".o-solutions-circle__item");

            // limpa estados
            allCenterItems.forEach((el) => el.classList.remove("active"));
            items.forEach((el) => {
                el.classList.remove("is-selected");
                el.setAttribute("aria-selected", "false");
            });

            if (idx === null || idx === undefined || idx < 0) {
                // volta ao conteúdo principal
                if (main) main.classList.add("active");
                return;
            }

            // center items sem o "main" (ordem 1..n) mapeiam 1:1 com os items do círculo
            const contentList = center.querySelectorAll(
                ".o-solutions-circle__center-item:not(.o-solutions-circle__center-item--main)"
            );
            const targetContent = contentList[idx];
            const targetItem = items[idx];

            if (targetContent) targetContent.classList.add("active");
            if (targetItem) {
                targetItem.classList.add("is-selected");
                targetItem.setAttribute("aria-selected", "true");
            }
        }

        /**
         * Inicializa um módulo do círculo
         */
        function initCircle(root) {
            const items = root.querySelectorAll(".o-solutions-circle__item");

            // Acessibilidade básica
            items.forEach((el, i) => {
                el.setAttribute("role", "button");
                el.setAttribute("tabindex", "0");
                el.setAttribute("aria-selected", "false");
                // guarda índice (fallback caso o PHP não injete data-index)
                if (!el.dataset.index) el.dataset.index = String(i);
            });

            // eventos
            const onActivate = (ev) => {
                const el = ev.currentTarget;
                const i = parseInt(el.dataset.index, 10);
                setActive(root, isNaN(i) ? null : i);
            };

            items.forEach((el) => {
                el.addEventListener("click", onActivate);
                el.addEventListener("keydown", (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onActivate.call(el, {
                            currentTarget: el,
                        });
                    }
                });
            });

            // estado inicial = conteúdo principal ativo
            setActive(root, null);
        }

        // Inicializa todos os módulos na página
        document.addEventListener("DOMContentLoaded", () => {
            document
                .querySelectorAll(".o-solutions-circle")
                .forEach(initCircle);
        });
    })();
}
